// extracted by mini-css-extract-plugin
module.exports = {"box_right":"box_right-1zPb30r_","ad":"ad-1qhSzHDC"};